import React from 'react';
import { Check, Star } from 'lucide-react';
import { mockData } from './mockData';

const Services = () => {
  const { services } = mockData;

  return (
    <section id="services" className="section">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">Choose Your AI Automation Plan</h2>
          <p className="body-large max-w-2xl mx-auto">
            Select the perfect plan for your business needs. All plans include setup, 
            training, and ongoing support to ensure your AI agents perform flawlessly.
          </p>
        </div>

        <div className="voice-grid max-w-4xl mx-auto">
          {services.map((service) => (
            <div 
              key={service.id} 
              className={`voice-card ${service.accent} hover-lift relative`}
            >
              {/* Popular Badge */}
              {service.popular && (
                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                  <div className="bg-orange-500 text-white px-3 py-1 rounded-full text-xs font-medium flex items-center gap-1">
                    <Star size={12} />
                    Most Popular
                  </div>
                </div>
              )}
              
              {/* Plan Header */}
              <div className="text-center mb-6">
                <h3 className="voice-card-title">{service.name}</h3>
                <p className="voice-card-description mb-4">{service.description}</p>
                <div className="mb-4">
                  <span className="heading-hero">{service.price}</span>
                  <span className="body-small">/{service.period}</span>
                </div>
              </div>

              {/* Features List */}
              <ul className="space-y-3 mb-8">
                {service.features.map((feature, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <Check size={16} className="text-green-600 mt-0.5 flex-shrink-0" />
                    <span className="body-small">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* CTA Button */}
              <button 
                onClick={() => document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' })}
                className={`btn-primary w-full mt-auto ${service.popular ? 'hover-scale' : ''}`}
              >
                Get Started with {service.name}
              </button>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="text-center mt-12">
          <p className="body-small text-gray-600 mb-4">
            All plans include 30-day money-back guarantee and dedicated support
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-500">
            <div>✓ Setup & Training Included</div>
            <div>✓ 24/7 AI Agent Monitoring</div>
            <div>✓ Monthly Performance Reports</div>
            <div>✓ Ongoing Optimization</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;